export const COLLAPSED = {
  WIDTH: 376,
  HEIGHT: 70,
};

export const COLLAPSED_AS_ROUNDED = {
  WIDTH: 100,
  HEIGHT: 90,
};

export const EXPANDED = {
  WIDTH: 376,
  HEIGHT: 549,
};
